<template>
  <div class="moreDetails">
    <van-sticky>
      <div
        class="moreDetailsNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">更多信息</span>
      </div>
    </van-sticky>
    <!-- 已完成所有进度 -->
    <CompleteOrder
      v-if="allComplete"
      :id="id"
      :judge_remark="judge_remark"
      :order_sn="order_sn"
      :order_status="order_status"
    ></CompleteOrder>
    <!-- 未完成所有进度 -->
    <UncompleteOrder :id="id" :order_sn="order_sn" v-else></UncompleteOrder>
  </div>
</template>
<script>
import UncompleteOrder from "./components/uncompleteOrder.vue";
import CompleteOrder from "./components/completeOrder.vue";
export default {
  data() {
    return {
      id: "",
      isiOSX: false,
      allComplete: false,
      judge_remark: null,
      order_sn: "",
      order_status: 5,
    };
  },
  components: { UncompleteOrder, CompleteOrder },
  created() {
    this.isiOSX = this.isIphoneX();
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    if (this.$route.query.allComplete) {
      this.allComplete = JSON.parse(this.$route.query.allComplete);
    }
    if (this.$route.query.judge_remark) {
      this.judge_remark = this.$route.query.judge_remark;
    }
    if (this.$route.query.order_sn) {
      this.order_sn = this.$route.query.order_sn;
    }
    if (this.$route.query.order_status) {
      this.order_status = this.$route.query.order_status;
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="less" scoped>
.moreDetails {
  min-height: 100%;
  background-color: #f5f6ff;
  .moreDetailsNav {
    background: #f5f6ff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
}
</style>
